import { AppBox, AppText } from "../../../../../commons/components";
import { ManageFootballSubTeam } from "../../../../../commons/models/football/admin/manage-football-sub-team";

interface SubTeamDeleteProps {
  subTeam: ManageFootballSubTeam;
}
export default function SubTeamDeleteInprogress({ subTeam }: SubTeamDeleteProps) {
  return (
    <AppBox flexDirection="column" gap="sm">
      <AppText>
        Deleting <strong>“{subTeam.name}”</strong> In Progress
      </AppText>
      <AppBox className="loader-line"></AppBox>
    </AppBox>
  );
}
